import { defineComponent as _defineComponent } from 'vue'
import OzBox, { OzBoxColors } from '@@/library/v4/components/OzBox.vue'
import type { OzMenuRowsRow } from 'library/v4/components/OzMenuRows.vue'
import OzMenuRows, { OzMenuRowsFocusStyle, OzMenuRowsSizePreset } from 'library/v4/components/OzMenuRows.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SurfaceDropdown',
  props: {
    label: null,
    rows: null,
    darkMode: { type: Boolean },
    containerStyle: null
  },
  emits: ['select-row'],
  setup(__props: any, { emit }) {




const onRowSelect = (event, payload) => {
  emit('select-row', event, payload)
}

return { __sfc: true,emit, onRowSelect, OzBox, OzBoxColors, OzMenuRows, OzMenuRowsFocusStyle, OzMenuRowsSizePreset }
}

})